export default {
  header: {
    title: 'Geschenkgutschein kaufen',
  },
  checkout_btn: {
    title: 'Zur Kasse',
  },
  items: {
    gift_card: {
      online: 'Geschenkgutschein nur online einlösbar',
      online_and_store: 'Geschenkgutschein (Online & vor Ort einlösbar)',
      title: 'Wähle deinen Wunschbetrag',
      description: 'Füge den Geschenkgutschein mit der gewünschten Anzahl zum Warenkorb hinzu',
    },
    expiration: {
      label: '3 Jahre gültig',
      title: 'Freude schenken!',
      description: 'Der Empfänger kann den Gutschein innerhalb von 3 Jahren flexibel einlösen.',
    },
    delivery: {
      label: 'Sofort als PDF per E-Mail',
      title: 'Sofortige Lieferung als PDF per E-Mail',
      description: 'Nach sicherer Zahlung erhältst du den Gutschein sofort.',
    },
  },
  form: {
    value: {
      title: 'Wähle den Gutscheinbetrag',
      custom: {
        label: 'Individuell',
        placeholder: 'Betrag zwischen {{min}} und {{max}} {{currency}} eingeben',
      },
    },
    quantity: {
      title: 'Anzahl',
    },
    email: {
      title: 'Wie lautet deine E-Mail-Adresse, damit wir dir den Geschenkgutschein zusenden können?',
      placeholder: 'Deine E-Mail-Adresse',
      error: 'Ungültige Email',
    },
  },
  confirmation: {
    title: {
      title: 'Geschenkgutschein kaufen?',
      subtitle_one: 'Möchtest du 1 Geschenkgutschein über {{value}} kaufen?',
      subtitle_other: 'Möchtest du {{count}} Geschenkgutscheine über {{value}} kaufen?',
    },
    description: {
      total: 'Gesamt:',
      email: 'E-Mail:',
      quantity: 'Anzahl',
      amount: 'Betrag',
    },
    footer: {
      cancel: 'Abbrechen',
      confirm: 'Bestätigen',
    },
  },
};
